/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { ICreateTransactionArgs } from '@services/tokenization-service/components';

interface ICreateTxnMessageInput {
  raw: ICreateTransactionArgs;
}

export class CreateTxnMessage {
  raw: ICreateTransactionArgs;
  input: any = [];
  inputObj: any = {};
  constructor({ raw }: ICreateTxnMessageInput) {
    this.raw = raw;
  }
}
